<div id="{{id}}" class="chart-container">
  <div id="{{id}}-chart" class="chart"></div>
</div>
